import React from "react";
import ForwardArrow from "../../../assets/svg/ForwardArrow";

function LinkWithArrows({ text }) {
  return (
    <p className="mt-[32px] flex items-center gap-[10px] justify-center text-center cursor-pointer group">
      <span>{text}</span>
      <span className="block -mt-[2px] group-hover:hidden">
        <ForwardArrow type="dark" />
      </span>
      <span className="hidden -mt-[2px] group-hover:block">
        <ForwardArrow type="light" />
      </span>
    </p>
  );
}

export default LinkWithArrows;
